<template>
  <div>
    <UserInformation/>
    <br>
    <div class="tip" v-if="requestForm.folio">
      <el-row type="flex">

        <el-col style="font-weight: bold; color: black" :span="12">
          <span style="font-style: italic">
             {{ requestForm.folio ? 'Folio: ' + requestForm.folio : '' }}
          </span>
          <br>
          <span>Usuario creador:</span>
          <span style="font-style: italic">
            {{
              requestForm.last_log_register.user.full_name
            }}
          </span>
          <br>
          <span>Perfil:</span>
          <span style="font-style: italic">
            {{
              requestForm.last_log_register.user.profile.name
            }}
          </span>
          <br>
          <span>Representación:</span>
          <span style="font-style: italic">{{ requestForm.office ? requestForm.office.representation_name : '' }}</span>
          <br>
          <span>Estatus:</span>
          <span style="font-style: italic">{{ requestForm.last_log.status.name }}</span>
        </el-col>
      </el-row>
    </div>
    <el-alert type="info"
              title="Atención..."
              :closable="true"
              show-icon>
      Acerque el cursor en los apartados donde se muestre el ícono <i style="font-size: 10px" class="fas fa-info"/>
      para mostrar detalles
    </el-alert>
    <div class="tip_warning"
         v-if="showAnex == false || showInformatic == false || showInvestigation == false || showJustification == false">
      <label class="el-form--label-top">Se recomienda el uso de audífonos o dispositivos de audio externos.
        <i class="fas fa-volume-up"></i>
      </label>
      <el-row>
        <el-col :span="6">
          <el-button type="text" icon="fas fa-video" @click="showVideos(1)">
            Dictamen Técnico
          </el-button>
        </el-col>
        <el-col :span="6">
          <el-button type="text" icon="fas fa-video" @click="showVideos(2)">
            Anexo Técnico
          </el-button>
        </el-col>
        <el-col :span="6">
          <el-button type="text" icon="fas fa-video" @click="showVideos(3)"
                     v-if="requestForm.last_log.cat_acquisition_status_id >= 51
                     && showInvestigation == false">
            Investigación de Mercado
          </el-button>
        </el-col>
        <el-col :span="6">
          <el-button type="text" icon="fas fa-video" @click="showVideos(4)"
                     v-if="requestForm.last_log.cat_acquisition_status_id >= 51
                     && showJustification == false">
            Justificación
          </el-button>
        </el-col>
      </el-row>
    </div>
    <el-backtop target=".tip">
      <span>test_up_text</span>
    </el-backtop>
    <br/>
    <HeaderSection icon="fas fa-clipboard-check"
                   :title="requestForm && requestForm.id? 'Edición de solicitud ':'Alta solicitud'">
      <template slot="buttons">
        <el-button
            size="medium"
            type="danger"
            icon="el-icon-arrow-left"
            @click="goToIndex">
          Regresar
        </el-button>
        <el-button
            size="medium"
            type="success"
            icon="fas fa-comments"
            @click="showCommentsDialog(requestForm.hash_id)">
        </el-button>
        <el-tooltip class="item" effect="dark" content="Down" placement="top-end">
          <el-button type="info"
                     plain
                     style="font-size: 20px !important;"
                     icon="el-icon-caret-bottom"
                     @click="goToBottom">
          </el-button>
        </el-tooltip>
      </template>
    </HeaderSection>
    <span v-if="showField">
             <el-row :gutter="20"
                     v-if="catalogs.catProductsOrServicesArticles &&  catalogs.catEquipmentTypes && catalogs.catProductsOrServicesArticles.length>0 &&  catalogs.catEquipmentTypes.length>0 ">
            <el-col :span="24">
                <el-form ref="requestForm" :model="requestForm" label-width="120px" label-position="top"
                         @submit.native.prevent>
                    <el-tabs type="card" v-model="activeTab">
                        <el-tab-pane label="Anexo Técnico" name="2">
                            <TechnicalAnnex :showField="showField"/>
                        </el-tab-pane>

                        <el-tab-pane
                            label="Investigación de Mercado" name="3">
                            <Third2019 v-if="showField"/>
                        </el-tab-pane>

                        <el-tab-pane
                            label="Justificación 2019"
                            name="4">
                            <Justification2019 v-if="showField"></Justification2019>
                        </el-tab-pane>

                    </el-tabs>


                  <!-- validea -->
                    <Validate :submitForm="submitForm"
                              :alias_this="aliasThis"
                              :submitFormValidate="submitFormValidate"
                              :serviceChangeStatus="serviceChangeStatus"/>


                </el-form>
            </el-col>
        </el-row>
        </span>
    <span v-if="!showField">
             <el-row :gutter="20"
                     v-if="catalogs.catProductsOrServicesArticles &&  catalogs.catEquipmentTypes && catalogs.catProductsOrServicesArticles.length>0 &&  catalogs.catEquipmentTypes.length>0 ">
            <el-col :span="24">
                <el-form ref="requestForm" :model="requestForm" label-width="120px" label-position="top"
                         @submit.native.prevent>
                    <el-tabs type="card" v-model="activeTab">
                        <el-tab-pane v-if="!showField && showInformatic"
                                     name="1"
                                     label="Dictamen Técnico Informático Regional">

                            <Informatic :showField="showField"/>

                        </el-tab-pane>

                        <el-tab-pane label="Anexo Técnico" name="2" v-if="showAnex">

                            <TechnicalAnnex :showField="showField"/>

                        </el-tab-pane>

                        <el-tab-pane v-if="requestForm.last_log.cat_acquisition_status_id >= 51
                         && requestForm.last_log.cat_acquisition_status_id < 81
                         && showInvestigation"
                                     label="Investigación de Mercado" name="3">
                            <Third v-if="!showField"/>
                        </el-tab-pane>

                        <el-tab-pane v-if="requestForm.last_log.cat_acquisition_status_id >= 51
                          && requestForm.last_log.cat_acquisition_status_id < 81
                          && showJustification"
                                     label="Justificación 2021"
                                     name="4">
                            <Justification :showField="showField"></Justification>
                        </el-tab-pane>

                    </el-tabs>

                  <!-- validea -->
                    <Validate :submitForm="submitForm"
                              :alias_this="aliasThis"
                              :submitFormValidate="submitFormValidate"
                              :serviceChangeStatus="serviceChangeStatus"/>



                </el-form>
            </el-col>
        </el-row>
        </span>


    <div style="margin: 120px">

    </div>


    <el-dialog
        @close="location.reload()"
        title="Apoyo Multimedia-Dictamen Técnico"
        :visible.sync="showModalInformatic"
        fullscreen>
      <el-row>
        <label class="el-form--label-top">Se recomienda el uso de audífonos o dispositivos de audio externos. <i
            class="fas fa-volume-up"></i></label>
        <el-col :span="24">
          <video-player class="video-player-box"
                        ref="videoPlayer1"
                        @ended="onPlayerEnded($event, 2)"
                        :controlBar="false"
                        :options="playerOptionsInformatic"
                        :playsinline="true"
                        customEventName="customstatechangedeventname">
          </video-player>
        </el-col>
      </el-row>
    </el-dialog>

    <el-dialog
        @close="location.reload()"
        title="Apoyo Multimedia-Anexo Técnico"
        :visible.sync="showModalAnex"
        fullscreen>
      <el-row>
        <label class="el-form--label-top">Se recomienda el uso de audífonos o dispositivos de audio externos. <i
            class="fas fa-volume-up"></i></label>
        <el-col :span="24">
          <video-player class="video-player-box"
                        ref="videoPlayer2"
                        @ended="onPlayerEnded($event, 3)"
                        :controlBar="false"
                        :options="playerOptionsAnex"
                        :playsinline="true"
                        customEventName="customstatechangedeventname">
          </video-player>
        </el-col>
      </el-row>
    </el-dialog>

    <el-dialog
        @close="location.reload()"
        title="Apoyo Multimedia-Investigación de Mercado"
        :visible.sync="showModalInvestigation"
        fullscreen>
      <el-row>
        <label class="el-form--label-top">Se recomienda el uso de audífonos o dispositivos de audio externos. <i
            class="fas fa-volume-up"></i></label>
        <el-col :span="24">
          <video-player class="video-player-box"
                        ref="videoPlayer3"
                        @ended="onPlayerEnded($event, 4)"
                        :controlBar="false"
                        :options="playerOptionsInvestigation"
                        :playsinline="true"
                        customEventName="customstatechangedeventname">
          </video-player>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog
        @close="location.reload()"
        title="Apoyo Multimedia-Justificación"
        :visible.sync="showModalJustification"
        fullscreen>
      <el-row>
        <label class="el-form--label-top">Se recomienda el uso de audífonos o dispositivos de audio externos. <i
            class="fas fa-volume-up"></i></label>
        <el-col :span="24">
          <video-player class="video-player-box"
                        ref="videoPlayer4"
                        @ended="onPlayerEnded($event, 5)"
                        :controlBar="false"
                        :options="playerOptionJustification"
                        :playsinline="true"
                        customEventName="customstatechangedeventname">
          </video-player>
        </el-col>
      </el-row>
    </el-dialog>

    <el-dialog
        :title="`Comentarios del la solicitud ${acquisitionComments.folio}`"
        :visible.sync="showComments"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="80%">

      <div v-if="acquisitionComments.comments.length == 0" style="margin-top: 1em">
        <el-alert
            title="No hay comentarios"
            type="info"
            :closable="false">
        </el-alert>
      </div>
      <div v-else>
        <el-collapse accordion>
          <el-collapse-item
              v-for="comment in acquisitionComments.comments"
              :key="comment.id"
              :name="comment.id">
            <template slot="title">
              {{ comment.user.full_name }} / {{ comment.user.profile.name }} /
              {{ comment.created_at | moment("D MMMM YYYY") }} / {{
                comment.status.name
              }}
            </template>
            <el-input type="textarea"
                      v-model="comment.comments"
                      style="word-break: break-word"
                      :disabled="(comment.user.cat_profile_id != infoUser.cat_profile_id)"
                      :autosize="{ minRows: 5, maxRows: 10}"
                      resize="none">
            </el-input>
          </el-collapse-item>
        </el-collapse>
      </div>
      <span slot="footer" class="dialog-footer">
                <el-button @click="showComments = false; acquisitionComments.comments = []">
                    Cerrar
                </el-button>
            </span>
    </el-dialog>


  </div>
</template>

<script>
import {mapState, mapGetters, mapActions, mapMutations} from "vuex";
import HeaderSection from '@/components/partials/HeaderSection';
import TechnicalAnnex from '@/components/views/acquisition/partials/TechnicalAnnex'
import Justification from '@/components/views/acquisition/partials/Justification'
import Justification2019 from '@/components/views/acquisition/partials/Justification2019'
import Third from '@/components/views/acquisition/partials/Third'
import Third2019 from '@/components/views/acquisition/partials/Third2019'
import Informatic from '@/components/views/acquisition/partials/InformaticOpinion'
import Validate from '@/components/views/acquisition/partials/Validate/Validate'

import UserInformation from '@/components/partials/UserInformation'


export default {
  components: {
    HeaderSection,
    TechnicalAnnex,
    Justification,
    Justification2019,
    Third,
    Validate,
    UserInformation,
    Informatic,
    Third2019
  },

  computed: {
    ...mapGetters("form", {
      requestForm: "requestForm",
      onlyRead: "onlyRead",
      catalogs: "catalogs",
      descriptions: "descriptionsAreas"
    }),
    ...mapState([
      'route'
    ]),
    aliasThis() {
      return this;
    },
    infoUser() {
      return this.$store.state.user
    },
  },

  data() {
    return {
      showField: null,
      activeTab: '1',
      showTab: false,
      showInvestigation: false,
      showJustification: false,
      showInformatic: false,
      showAnex: false,
      showModalAnex: false,
      showModalInformatic: false,
      showModalInvestigation: false,
      showModalJustification: false,
      acquisitionComments: {comments: []},
      showComments: false,
      playerOptionsInformatic: {
        muted: true,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: "video/mp4",
          src: "/storage/Dictamen técnico 27-08-21.MP4"
        }],
        poster: "/img/sre_new_header.png",
      },
      playerOptionsAnex: {
        muted: true,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: "video/mp4",
          src: "/storage/Anexo Técnico 27-08-21.MP4"
        }],
        poster: "/img/sre_new_header.png",
      },
      playerOptionsInvestigation: {
        muted: true,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: "video/mp4",
          src: "/storage/MSE- INVESTIGACIÓN V.mp4"
        }],
        poster: "/img/sre_new_header.png",
      },
      playerOptionJustification: {
        muted: true,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 10.0],
        sources: [{
          type: "video/mp4",
          src: "/storage/MSE-JUSTIFICACIÓN.mp4"
        }],
        poster: "/img/sre_new_header.png",
      },
    }
  },

  mounted() {
    this.showField = null;
    this.$refs?.videoPlayer1?.player?.controlBar?.progressControl?.disable();
    this.$refs?.videoPlayer2?.player?.controlBar?.progressControl?.disable();
    this.$refs?.videoPlayer3?.player?.controlBar?.progressControl?.disable();
    this.$refs?.videoPlayer4?.player?.controlBar?.progressControl?.disable();
    setTimeout(() => {
      if (this.requestForm && this.requestForm.created_at) {
        let _date = moment(this.requestForm.created_at).format('Y');
        this.showField = _date <= '2019';
      }
      this.validateVideos()
    }, 3000)
  },

  created() {

    this.init();
    /*axios.get('/api/acquisitions/acquisitions-statuses').then(response => {

    })*/
  },


  methods: {
    ...mapActions('form', {
      fetchSigle: "fetchSigle",
      initService: "initService",
      fetchDescriptions: "fetchDescriptions"
    }),
    ...mapMutations('form', {
      clear: "clear",
      resetProgressBar: "resetProgressBar",
      fetchSingleSuccess: "fetchSingleSuccess"
    }),
    showLoading() {
      this.$store.dispatch(
          "loading/spinner",
          {msg: "Cargando Datos...", status: true},
          {root: true}
      );
    },
    hideLoading() {
      this.$store.dispatch("loading/spinner", {}, {root: true});
    },

    init() {
      if (this.route.params.id) {
        return this.fetchSigle({
          crypt_id: this.route.params.id
        }).then((res) => {
          this.initService()
              .then(() => {
                setTimeout(() => {
                  this.checkValidate();
                  this.fetchDescriptions();
                }, 1500);
              });
          document.title = "F: " + this.requestForm.folio + " Módulo de servicios en el exterior "
        }).catch((err) => {
        });
      } else {
        this.clear();
        this.initService()
            .then(() => {
              setTimeout(() => {
                this.checkValidate();
                this.fetchDescriptions();
              }, 2000);
            });
      }

    },

    setRefs() {
      return this.$refs
    },

    submitForm(status, comments) {
      this.saveFormService(status, comments);

    },
    submitFormValidate(status, comments) {
      this.$refs['requestForm'].validate((valid) => {
        if (valid) {
          if (this.showField) {
            if (this.requestForm.cat_acquisition_type_id == 1 &&
                (
                    this.filterSection(this.requestForm.documents, 8) === false ||
                    this.filterSection(this.requestForm.documents, 9) === false
                )
            ) {
              this.$store.dispatch('notifications/warning', {msg: 'En la sección investigación de mercado hacen falta los archivos de plano y fotografía de bienes.'}, {root: true});
              return true;
            }
            if (this.filterSection(this.requestForm.documents, 4) === false) {
              this.$store.dispatch('notifications/warning', {msg: 'Hace falta documentos firmados en la  sección anexo técnico.'}, {root: true});
              return true;
            }
            if (this.filterSection(this.requestForm.documents, 6) === false) {
              this.$store.dispatch('notifications/warning', {msg: 'Hace falta documentos firmados en la  sección investigación de mercado.'}, {root: true});
              return true;
            }
            if (this.filterSection(this.requestForm.documents, 5) === false) {
              this.$store.dispatch('notifications/warning', {msg: 'Hace falta documentos firmados en la  sección justificación 2019.'}, {root: true});
              return true;
            }

            this.saveFormService(status, comments);
          } else {
            if (this.filterSection(this.requestForm.documents, 10) === false) {
              this.$store.dispatch('notifications/warning', {msg: 'Se requiere el documento firmado, en la sección "Dictamen Técnico Informático Regional".'}, {root: true});
              return true;
            }
            if (this.filterSection(this.requestForm.documents, 4) === false) {
              this.$store.dispatch('notifications/warning', {msg: 'Se requiere el documento firmado, en la sección "Anexo Técnico".'}, {root: true});
              return true;
            }
            if (this.filterSection(this.requestForm.documents, 6) === false && this.requestForm.last_log.cat_acquisition_status_id >= 51) {
              this.$store.dispatch('notifications/warning', {msg: 'Se requiere el documento firmado, en la sección "Investigación de Mercado".'}, {root: true});
              return true;
            }
            if (this.filterSection(this.requestForm.documents, 5) === false && this.requestForm.last_log.cat_acquisition_status_id >= 51) {
              this.$store.dispatch('notifications/warning', {msg: 'Se requiere el documento firmado, en la sección "Justificación".'}, {root: true});
              return true;
            }
            this.saveFormService(status, comments)
          }

        } else {
          this.$store.dispatch('notifications/warning', {msg: 'Debe completar todos los campos obligatorios'}, {root: true});
        }
      });
    },
    serviceChangeStatus(status, comments, acquisition_id) {
      this.showLoading();
      let profile = this.$store.state.user.profile;

      let data = {
        acquisition_id: this.requestForm.id ? this.requestForm.id : acquisition_id,
        status: status,
        comments: comments
      };

      // <|::: Informatico Regional :::|>
      if (profile === 11 && [4345].includes(status)) {
          
          let dataVoBoInfraestructure = {
            acquisition_id: this.requestForm.id ? this.requestForm.id : acquisition_id,
            status: 43,
            comments: comments
          }
          let dataVoBoServices = {
            acquisition_id: this.requestForm.id ? this.requestForm.id : acquisition_id,
            status: 45,
            comments: comments
          }

          Promise.all([
            axios.post('/api/acquisitions/status-process', dataVoBoInfraestructure),
            axios.post('/api/acquisitions/status-process', dataVoBoServices)
          ])
            .then(responses => {
              this.hideLoading();

              const response1 = responses[0];
              const response2 = responses[1];

              if (response1.data.success && response2.data.success) {
                this.$store.dispatch('notifications/ok', {msg: response1.data.message}, {root: true});
                this.$router.push('/solicitudes');
              } else {
                this.$store.dispatch('notifications/error', {msg: 'No se pudo completar la acción para una o ambas áreas.'}, {root: true});
              }
            })
            .catch(error => {
              this.hideLoading();
              this.$store.dispatch('notifications/error', { msg: 'No se pudo completar la acción.' }, { root: true });
            });

            return;
        }
      // <|::: Informatico Regional :::|>

      axios.post('/api/acquisitions/status-process', data).then(response => {
        this.hideLoading();
        if (response.data.success) {
          this.$store.dispatch('notifications/ok', {msg: response.data.message}, {root: true});
          this.$router.push('/solicitudes');
        } else {
          this.$store.dispatch('notifications/error', {msg: 'No se pudo guardar la solicitud.'}, {root: true});

        }
      }).catch(error => {
        this.hideLoading();
        this.$store.dispatch('notifications/error', {msg: 'No se pudo completar la acción.'}, {root: true});
      });
    },
    filterSection(data, section) {
      if (!data) return false;
      let filterData = data.filter((item) => item.section_id == section);
      return filterData && filterData.length >= 1 ? true : false;
    },
    saveFormService(status, comments) {

      if (!this.requestForm.product_or_service_id && this.showField) {
        this.$store.dispatch('notifications/warning', {msg: 'El campo nombre de servicio es requerido.'}, {root: true});
        return true;
      }
      if (!this.showField && !this.requestForm.service_name_id) {
        this.$store.dispatch('notifications/warning', {
          msg: 'El campo 1. Tipo de Solicitud y el campo 2.' +
              ' Nombre de la contratación son requeridos para registrar una solicitud.'
        }, {root: true});
        return true;
      }


      this.showLoading();

      let method = null;
      let url = null;

      if (this.route.params.id) {
        method = 'PUT';
        url = '/api/acquisitions/service/' + this.route.params.id;
      } else {
        method = 'POST';
        url = '/api/acquisitions/service';
      }


      let _requestForm = this.requestForm;


      const options = {
        method: method,
        data: {
          data: _requestForm,
          status_alias: status
        },
        url: url
      };
      axios(options).then(response => {
        this.hideLoading();
        if (response.data.success) {
          if (status == 2 || status == 14 || status == 15 || status == 35 || status == 113 || status == 114) {
            this.serviceChangeStatus(status, comments, response.data.acquisition_id);
          } else {

            this.$store.dispatch('notifications/ok', {msg: response.data.message}, {root: true});
            this.$router.push({
              path: '/solicitudes/editar/' + response.data.hash_id
            });
            this.fetchSingleSuccess(response.data)
          }
        } else if (response.data.missingData) {

          _.forEach(response.data.message, item => {
            setTimeout(() => {
              this.$store.dispatch('notifications/warning', {msg: item}, {root: true});
            }, 1000)
          });

        } else if (!_.isArray(response.data.message)) {
          this.$store.dispatch('notifications/error', {msg: response.data.message}, {root: true});
        }
      }).catch(error => {
        this.hideLoading();
        this.$store.dispatch('notifications/error', {msg: 'No se pudo completar la acción.'}, {root: true});
      });
    },
    goToIndex() {
      document.title = "Módulo de servicios en el exterior"
      this.$router.push('/solicitudes');
    },

    //
    checkValidate() {
      let objectTotal = {
        totalFields: 0,
        totalErrors: 0,
        percentage: 0

      };


      try {

        objectTotal.totalFields = this.$refs.requestForm.fields.filter((f) => f.isRequired && f.fieldValue != 0).length;

        objectTotal.totalErrors = this.$refs.requestForm.fields.filter(f => {
          return f.isRequired && ((Array.isArray(f.fieldValue) && f.fieldValue.length == 0) || (!Array.isArray(f.fieldValue) && (f.fieldValue == null || f.fieldValue == undefined || f.fieldValue === "")));
        }).length;


        objectTotal.percentage = !isNaN(parseInt((objectTotal.totalFields - objectTotal.totalErrors) * 100 / objectTotal.totalFields)) ?
            parseInt((objectTotal.totalFields - objectTotal.totalErrors) * 100 / objectTotal.totalFields) : 0;


        let errorTmp = this.$refs.requestForm.fields.filter(f => {
          return f.isRequired && ((Array.isArray(f.fieldValue) && f.fieldValue.length == 0) || (!Array.isArray(f.fieldValue) && (f.fieldValue == null || f.fieldValue == undefined || f.fieldValue === "")));
        });
        // console.log("validate error:",errorTmp);

      } catch (err) {

        // console.log("err validate:", err);
      }
      this.resetProgressBar(objectTotal);

    },

    validateVideos() {
      let _validateInformatic = this.infoUser.videos?.filter(up => up.video_id == 2); //anexo
      let _validateAnex = this.infoUser.videos?.filter(up => up.video_id == 3); //anexo
      let _validateInvestigation = this.infoUser.videos?.filter(up => up.video_id == 4); //inv
      let _validateJus = this.infoUser.videos?.filter(up => up.video_id == 5); //ju
      this.showInformatic = _validateInformatic?.length > 0;
      this.showAnex = _validateAnex?.length > 0;
      this.showInvestigation = _validateInvestigation?.length > 0;
      this.showJustification = _validateJus?.length > 0;
      if (this.infoUser.profile != 2 && this.infoUser.profile != 1) {
        this.showInformatic = true;
        this.showAnex = true;
        this.showInvestigation = true;
        this.showJustification = true;
      }

      if (!this.showInformatic) {
        this.$message.info("Visualice el contenido para ingresar el Dictamen Técnico")
      }
      if (!this.showAnex) {
        setTimeout(() => {
          this.$message.info("Visualice el contenido para ingresar el Anexo Técnico")
        }, 500)
      }
    },

    goToBottom() {
      $('#body-content').animate({scrollTop: 10000}, 'slow');
    },

    showVideos(type) {
      if (type === 1) {
        this.showModalInformatic = true;
        this.showModalAnex = false
      }
      if (type == 2) {
        this.showModalInformatic = false;
        this.showModalAnex = true
      }
      if (type == 3) {
        this.showModalInformatic = false;
        this.showModalInvestigation = true
      }
      if (type == 4) {
        this.showModalJustification = true
      }

    },

    showCommentsDialog(acquisitionId) {
      axios.post('/api/acquisitions/acquisition-comments', {acquisitionId: acquisitionId})
          .then(response => {
            let _comments = response.data.acquisition.comments;
            this.acquisitionComments.comments = _comments;
            this.acquisitionComments.folio = response.data.acquisition.folio;
          });
      this.showComments = true;
    },

    onPlayerEnded(player, type) {
      if (player) {
        let _data = {
          user: this.infoUser.id,
          video: type
        }
        axios.post('/api/user-video', _data).then(response => {
          if (response.data.success) {
            this.$message.success(response.data.message);
            if (type == 2) {
              this.showInformatic = true;
              this.showModalInformatic = false;
            }
            if (type == 3) {
              this.showAnex = true;
              this.showModalAnex = false;
            }
            if (type == 4) {
              this.showInvestigation = true;
              this.showModalInvestigation = false;

            }
            if (type == 5) {
              this.showJustification = true;
              this.showModalJustification = false;
            }
          } else {
            this.$message.error(response.data.message)
          }
        }).catch(e => {
          console.log("error ", e)
        })

      }
    }
    //


  },
  watch: {
    'requestForm': {
      handler(after, before) {
        this.checkValidate();
      },
      deep: true
    },
  },


}


</script>
<style>
.test-scroll {

}
</style>
